import { DarkPalette } from "./palettes/darkPalette";
import { LightPalette } from "./palettes/lightPalette";
import { MODERN_BORDER } from "./styles/modernVariables";
import { ICustomTheme } from "./types/ICustomTheme";

const baseShapeConfig = {
  borderRadius: parseInt(MODERN_BORDER.radius.md), // 8px
  borderRadiusDialog: parseInt(MODERN_BORDER.radius["2xl"]), // 20px
};

const baseTypographyConfig = {
  fontFamily: [
    "Inter",
    "Outfit",
    "system-ui",
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Arial",
    "sans-serif",
  ].join(","),
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
};

export const DarkThemeOptions: ICustomTheme = {
  palette: DarkPalette,
  shape: baseShapeConfig,
  typography: baseTypographyConfig,
};

export const LightThemeOptions: ICustomTheme = {
  palette: LightPalette,
  shape: baseShapeConfig,
  typography: baseTypographyConfig,
};
